module.exports = __webpack_public_path__ + "img/20MY_PH_EU_LHD_INSTYLE_P_IP_190523.9a72d4d4.jpg";